module.exports = __webpack_public_path__ + "img/ico_descarga.6f93eb40.svg";